import {IconButton} from '@common/components/Button';
import {ReactComponent as EditIcon} from 'app/gakki/assets/edit.svg';
import {ReactComponent as TrashIcon} from 'app/gakki/assets/trash.svg';

type ControlPanelProps = {
  onEdit: () => void;
  onRemove: () => void;
};
function ControlPanel({onEdit, onRemove}: ControlPanelProps) {
  return (
    <div
      className={
        'h-[43px] pr-[24px] bg-[#eff0f1] flex justify-end items-center'
      }
    >
      <IconButton onClick={onRemove} data-test-id={'remove-btn'}>
        <TrashIcon/>
        刪除
      </IconButton>
      <IconButton onClick={onEdit} data-test-id={'edit-btn'}>
        <EditIcon/>
        編輯
      </IconButton>
    </div>
  );
}

export default ControlPanel;
